import { gql } from '@apollo/client';

export const GET_PRODUCT = gql`
  query GetProduct($getProductId: ID!, $siteId: ID) {
    getProduct(id: $getProductId, siteId: $siteId) {
      id
      name

      siteIds
      shortDescription

      fullDescription

      instruction

      terms

      image
      countries
      baseCurrencyId
      baseCurrency {
        id
        name
      }
      category {
        id
        name
      }
      skus {
        id
        name

        value
      }
      preset {
        isPreset
        presetName
      }
    }
  }
`;
